import React, {Component} from "react";
import {Button, Modal} from "antd";
import AppEntity from "../../types/AppEntity";
import ApplicationForm from "../application-form/ApplicationForm";
import {FormType} from "../../types/FormType";
import styles from "../../theme/Dialog.module.css";

interface ApplicationFormDialogProps {
    type: FormType
    app?: AppEntity
    isOpen: boolean
    onClose: (closeDialog?: boolean) => void
}

interface ApplicationFormDialogState {
    isLoading: boolean
}

export default class ApplicationFormDialog extends Component<ApplicationFormDialogProps, ApplicationFormDialogState> {
    private applicationFormRef = React.createRef<ApplicationForm>();

    state = {isLoading: false}

    submit = () => {
        this.applicationFormRef.current?.formRef.current?.submit()
    }

    handleSubmitStart = () => {
        this.setState({isLoading: true})
    }

    handleSubmitEnd = (closeDialog: boolean = true) => {
        this.setState({isLoading: false})
        this.props.onClose(closeDialog);
    }

    handleReset = () => {
        this.applicationFormRef.current?.onReset()
    }

    handleClose = () => {
        if (this.state.isLoading) return;
        this.props.onClose();
    }

    render() {
        const isCreate = this.props.type === FormType.CREATE;
        return <Modal
            title={isCreate ? "Upload build" : `Edit ${this.props.app?.name}`}
            open={this.props.isOpen}
            onCancel={this.handleClose}
            centered
            width="min(600px, calc(100vw - 24px))"
            mask={{closable: false}}
            keyboard={!this.state.isLoading}
            destroyOnHidden
            className={styles.dialog}
            footer={
                <div className={styles.footer}>
                    <p className={styles.footerNote}>
                        {isCreate ? "Uploads stay drafts until you release them." : "Changes apply to this build right away."}
                    </p>
                    <div className={styles.footerActions}>
                        <Button onClick={this.handleReset} disabled={this.state.isLoading}>Reset</Button>
                        <Button type="primary" loading={this.state.isLoading} onClick={this.submit}>
                            {isCreate ? "Upload" : "Save changes"}
                        </Button>
                    </div>
                </div>
            }
        >
            <ApplicationForm onSubmitStart={this.handleSubmitStart}
                             onSubmitEnd={this.handleSubmitEnd}
                             app={this.props.app}
                             type={this.props.type}
                             ref={this.applicationFormRef}/>
        </Modal>
    }
}
